import * as React from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
} from "@mui/material";

import { Danger } from "react-iconly";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WarningPopup({
  open,
  handleClose,
  message,
  isSubscribed,
  updateSubscription,
  changefee,
  fee,
}) {
  const { t } = useTranslation("common");
  return (
    <Box color="default">
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "white",
            boxShadow: "none",
            color: "#000000",
            borderRadius: "4px",
            padding: 0,
            width: "343px",
            height: "185px",
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Danger
            width={"100px"}
            height={"100px"}
            set="light"
            primaryColor="#FFEE20"
          />
          <DialogContentText sx={{}} color="secondary">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            sx={{ maxWidth: "150px", padding: "10px 35px" }}
            color="secondary"
            onClick={() =>
              isSubscribed ? updateSubscription(changefee, fee) : handleClose()
            }
          >
            {t("warning.button1")}
          </Button>
          <Button
            variant="contained"
            onClick={() => handleClose()}
            sx={{ maxWidth: "150px", padding: "10px 35px" }}
            color="secondary"
          >
            {t("warning.button2")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
